import React from 'react'

import { ScreenPicker } from '../../ScreenPicker'
import SharedSections from './SharedSections'

const TopItems = ({ screen, disabled, onChange }) => {
  const content = screen?.content
  return (
    <ScreenPicker
      screenName={screen?.meta?.name}
      screens={content.topMenuItems}
      onChange={onChange('topMenuItems')}
      disabled={disabled}
      multiple
    />
  )
}

const BottomCarousel = ({ screen, disabled, onChange }) => {
  const content = screen?.content
  return (
    <ScreenPicker
      screenName={screen?.meta?.name}
      screens={content.carouselContent}
      onChange={onChange('carouselContent')}
      disabled={disabled}
      multiple
    />
  )
}

export default [
  { label: 'Top Items', content: TopItems },
  { label: 'Bottom Carousel', content: BottomCarousel },
  ...SharedSections,
]
